/* eslint-disable no-console */
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { contentfulActions } from '../redux/Slices/ContentfulSlice';
import { ADD_HOPE_THANK_YOU, FIELD_TITLE, FIELD_PAGE, ADD_HOPE, Order_Tracking, Gift_Card } from '../constants';
import { appendLocaleInCMSRequest } from '../network';
export function* fetchContent(action) {
    try {
        const { payload } = action;
        const contentfulReducerResp = yield select((state) => state?.contentfulReducer?.response);
        const result = yield call(payload?.contentful?.getEntries, appendLocaleInCMSRequest(payload.query));
        let response = { ...contentfulReducerResp };
        if (payload?.query?.[FIELD_PAGE] === ADD_HOPE) {
            response.addHope = result;
        }
        else {
            switch (payload?.query?.[FIELD_TITLE]) {
                case ADD_HOPE_THANK_YOU:
                    response.addHopeThankYou = result;
                    break;
                case Order_Tracking:
                    response.orderTracking = result;
                    break;
                case Gift_Card:
                    response.giftCardContent = result;
                    break;
                default:
                    response = result;
            }
        }
        yield put(contentfulActions?.fetchSuccess(response));
    }
    catch (error) {
        console.log('Failed to fetch content', error);
        yield put(contentfulActions?.fetchFailed(error.message));
    }
}
export default function* contentfulSaga() {
    yield takeLatest(contentfulActions?.fetch?.type, fetchContent);
}
